import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';

export interface IMenuItem {
    id?: string | null;
    description?: string | null;
    href?: string | null;
    children?: IMenuItem[] | null;
    isExpanded?: boolean;
}

export interface IMenu {
    activeHref: string | null;
}

@autoinject
export class NavigationService {

    constructor(private readonly env: EnvironmentService, private readonly transitional: TransitionalManager) {
    }

    public resolveUrl(menuItem: IMenuItem): string {
        if(!menuItem || !menuItem.href) {
            return '';
        }
        const { id, href } = menuItem;
        if(id && href.startsWith('~/')) {
            const parts = id.split('.');
            if(parts.length >= 2) {
                return this.env.resolveUrl(`~/#/${this.transitional.route}/${parts[1]}`);
            }
            return this.env.resolveUrl(href);
        }
        // TODO: consider using router to determine URL
        return this.env.resolveUrl(`~/#/${href}`);
    }

}
